import React, { useState } from "react";
import { getStorage, ref, uploadBytes, getDownloadURL, deleteObject } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";

const storage = getStorage();

export default function EditParticipationForm({ data, index, onSave, onCancel }) {
    const [form, setForm] = useState({
        ...data,
        isAchievement: data?.isAchievement ?? false, // ✅ default false
    });
    const [error, setError] = useState("");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((f) => ({ ...f, [name]: value }));
    };

    const handleFileUpload = async (e) => {
        setError("");
        const files = Array.from(e.target.files);

        for (const file of files) {
            if (file.size > 1024 * 1024) {
                setError("Fail terlalu besar. Maksimum 1MB.");
                continue;
            }

            const fileRef = ref(storage, `media/${uuidv4()}_${file.name}`);
            const snap = await uploadBytes(fileRef, file);
            const url = await getDownloadURL(snap.ref);

            setForm((f) => ({ ...f, media: [...(f.media || []), url] }));
        }
    };

    const handleDeleteImage = async (urlToDelete) => {
        const confirmDelete = window.confirm("Anda pasti mahu padam gambar ini?");
        if (!confirmDelete) return;

        try {
            const path = decodeURIComponent(new URL(urlToDelete).pathname.split("/o/")[1].split("?")[0]);
            const fileRef = ref(storage, path);
            await deleteObject(fileRef);

            setForm((f) => ({
                ...f,
                media: (f.media || []).filter((url) => url !== urlToDelete),
            }));
        } catch (err) {
            console.error("Gagal padam gambar:", err);
            setError("Gagal padam gambar.");
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(index, form);
    };

    return (
        <form className="edit-form" onSubmit={handleSubmit}>
            <h4>Edit Participation</h4>
            <div style={{ display: "flex", alignItems: " center" }}>

                <input
                    style={{ width: "50px" }}
                    type="checkbox"
                    checked={form.isAchievement}
                    onChange={(e) =>
                        setForm((prev) => ({ ...prev, isAchievement: e.target.checked }))
                    }
                    id="isAchievement"
                />
                <label htmlFor="isAchievement" style={{ margin: 0 }}>
                    Is Achievement
                </label>


            </div>
            <input name="name" value={form.name} onChange={handleChange} placeholder="Name" required />
            <input name="achievement" value={form.achievement} onChange={handleChange} placeholder="Achievement" />
            <input name="level" value={form.level} onChange={handleChange} placeholder="Level" />
            <input name="location" value={form.location} onChange={handleChange} placeholder="Location" />


            <input type="file" accept="image/*" multiple onChange={handleFileUpload} />

            {error && <p style={{ color: "red" }}>{error}</p>}

            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", marginTop: "10px" }}>
                {form.media?.map((url, i) => (
                    <div key={i} style={{ position: "relative", display: "inline-block" }}>
                        <img src={url} alt={`Uploaded ${i}`} style={{ width: 120, borderRadius: 6 }} />
                        <button
                            type="button"
                            onClick={() => handleDeleteImage(url)}
                            style={{
                                position: "absolute",
                                top: -8,
                                right: -8,
                                background: "red",
                                color: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: 24,
                                height: 24,
                                cursor: "pointer",
                            }}
                            title="Delete"
                        >
                            &times;
                        </button>
                    </div>
                ))}
            </div>

            <div className="participation-buttons" style={{ marginTop: 16 }}>
                <button type="submit">Save</button>
                <button type="button" onClick={onCancel}>Cancel</button>
            </div>
        </form>
    );
}
